import {
  getGroupData,
  getSelectedPeriod,
} from "../../../../services/GroupContext";
import { processDateJS } from "../../../../utils/dateProcessor";
import {
  findAdjustedCapsForCompany,
  getNonConsentingStatus,
} from "../utils/fullReturnOutputUtils";
import { getRelevantGroupCompanies } from "../utils/helpers";
import { getAllocatedRestrictionsMetrics } from "../utils/metrics";

const getMetricValuesFromAPData = (apData, metric, count) => {
  const values = [];

  for (let i = 0; i < count; i++) {
    //JCW TO-DO - To discuss with Katya whether we need a sort function in here to make sure the earliest is first.
    const value = apData[i]
      ? metric === "end_date"
        ? processDateJS(apData[i][metric]).format("DD/MM/YYYY")
        : apData[i][metric]
      : "";

    values.push(value);
  }

  return values;
};

export const getAllocatedRestrictionsCoreRows = () => {
  const savedData = getGroupData();
  const excelData = getAllocatedRestrictionsMetrics();
  const companies = getRelevantGroupCompanies();
  const adjustedCaps = getSelectedPeriod()?.adjusted_caps;

  const allocatedRestrictionsList = [
    [
      "",
      "Index no.",
      "Name of company",
      "Enter N if non-consenting",
      "Dates of company APs",
      "",
      "",
      "Disallowance",
      "Disallowance",
      "Disallowance",
      "",
    ],
    [
      "",
      "",
      "Cells below copy from sheet 3",
      "",
      "AP1 ends",
      "AP2 ends",
      "AP3 ends",
      "Relevant AP 1",
      "Relevant AP 2",
      "Relevant AP 3",
      "",
    ],
    [
      "",
      "",
      "",
      "",
      "DD/MM/YYYY",
      "DD/MM/YYYY",
      "DD/MM/YYYY",
      'Enter an amount or "0" (or leave blank)',
      "",
      "",
      "",
    ],
  ];

  const numOfCompanies = companies.length;
  const nonConsentingCompMap = getNonConsentingStatus(getSelectedPeriod(), companies);
  for (let i = 0; i < 300; i++) {
    let rowNumber = i + 1;
    let row = ["", rowNumber, "", "", "", "", "", "", "", ""];

    if (i < numOfCompanies) {
      let companyName = companies[i].company_name;

      let companyNC = nonConsentingCompMap.get(companies[i].company_ID) ? "NC" : "C";

      let adjustedCapsForCompany = findAdjustedCapsForCompany(
        adjustedCaps,
        companies[i].company_ID,
      );

      const apEndDates = getMetricValuesFromAPData(
        adjustedCapsForCompany,
        "end_date",
        3,
      );

      const apDisallowances = getMetricValuesFromAPData(
        adjustedCapsForCompany,
        "cpd_total_gbp",
        3,
      );

      row = [
        "",
        rowNumber,
        companyName,
        companyNC,
        ...apEndDates,
        ...apDisallowances,
      ];
    }

    allocatedRestrictionsList.push(row);
  }

  const allocatedRestrictionsFooter = [
    [],
    excelData.aR_Row316,
    excelData.aR_Row317,
    [],
    ["", "Key"],
    ["", "Descriptive field or date", , "Numerical entry, £", "", "Note"],
  ];

  const rows = allocatedRestrictionsList.concat(allocatedRestrictionsFooter);

  return rows;
};

export const getDisallowancesTableRows = () => {
  const adjustedCaps = getSelectedPeriod()?.adjusted_caps;

  const disallowancesList = [
    [
      "",
      "Name of company",
      "Consent Status",
      "Disallowance allocated to company (GBP)",
      "Election to override default order (s377(3)) applied?",
    ],
  ];

  const allocationDisallowancesData = adjustedCaps?.filter(
    (cap) => cap?.cpd_total_gbp,
  );
  const numOfDisallowances = allocationDisallowancesData?.length || 0;

  for (let i = 0; i < 300; i++) {
    let row = ["", "", "", "", ""];

    if (i < numOfDisallowances) {
      let cap = allocationDisallowancesData[i];
      let companyName = cap?.company_name || "";
      let nonCondentingStatus = cap?.non_consenting_company ? "Yes" : "No";
      let disallowance = cap?.cpd_total_gbp?.toLocaleString();
      let apply_s377_3_election = cap?.apply_s377_3_election ? "Yes" : "No";

      row = [
        "",
        companyName,
        nonCondentingStatus,
        disallowance,
        apply_s377_3_election,
      ];
    }

    disallowancesList.push(row);
  }

  return disallowancesList;
};

export const getAllocatedRestrictionsExcelData = (excelData) => {
  const allocatedRestrictionsHeader = [
    [],
    ["", "Interest Restriction Return Page 5"],
    [],
    [
      "",
      "Statement of allocated interest restrictions (Full return and where interest restriction arises, only)",
    ],
    [],
    ["", "Fields below copy from p1"],
    excelData.ukGC_Row7,
    excelData.ukGC_Row8,
    excelData.ukGC_Row9,
    excelData.ukGC_Row10,
    [],
  ];

  const allocatedRestrictionsCoreRows = getAllocatedRestrictionsCoreRows();
  const rows = allocatedRestrictionsHeader.concat(
    allocatedRestrictionsCoreRows,
  );

  return rows;
};
